import { createSlice } from '@reduxjs/toolkit';

// Slice
export const tokenSlice = createSlice({
  name: 'token',
  initialState: {
    token: ''
  },
  reducers: {
    setTokenData: (state, action) => {
      state.token = action.payload;
    }
  },
});

// Actions
export const { setTokenData } = tokenSlice.actions;

// Selector
export const tokenState = state => state.token;

// Reducer
export default tokenSlice.reducer;
